export const MONTH_YEAR_LABELS = {
  PLACEHOLDER: $localize`MM.JJJJ`,
  REQUIRED: $localize`Dieses Feld ist erforderlich`,
  INVALID_FORMAT: $localize`Ungültiges Datum. Bitte verwenden Sie das Format MM.JJJJ (z.B. 03.2025).`,
} as const;
